
import React from 'react';
import { Helmet } from 'react-helmet';
import Navbar from '@/components/layout/Navbar';
import Footer from '@/components/layout/Footer';
import HeroSection from '@/components/contact/HeroSection';
import ContactInfo from '@/components/contact/ContactInfo';
import ContactForm from '@/components/contact/ContactForm';
import MapSection from '@/components/contact/MapSection';

const Contact = () => {
  // JSON-LD structured data for LocalBusiness
  const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "name": "TreguIm",
    "image": "https://treguim.org/logo512.png",
    "url": "https://treguim.org",
    "telephone": "+355 69 123 4567",
    "email": "info@treguim.org",
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "Rruga e Kavajes",
      "addressLocality": "Tiranë",
      "postalCode": "1001",
      "addressCountry": "AL"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "41.3275",
      "longitude": "19.8187"
    },
    "openingHoursSpecification": [
      {
        "@type": "OpeningHoursSpecification",
        "dayOfWeek": [
          "Monday",
          "Tuesday",
          "Wednesday",
          "Thursday",
          "Friday"
        ],
        "opens": "09:00",
        "closes": "17:00"
      }
    ]
  };

  return (
    <div className="flex flex-col min-h-screen bg-white">
      <Helmet>
        <title>Kontakt | TreguIm - Platforma Dixhitale e Shqipërisë</title>
        <meta name="description" content="Na kontaktoni për çdo pyetje, sugjerim apo bashkëpunim. Ekipi ynë i shërbimit ndaj klientit është i gatshëm t'ju ndihmojë me çdo kërkesë." />
        <meta name="keywords" content="kontakt treguim.org, kontakto shitësin, ndihma për blerësin, shërbimi ndaj klientit treguim.org, kontakt marketplace shqipëri" />
        <meta property="og:title" content="Kontakt | TreguIm" />
        <meta property="og:description" content="Na kontaktoni për çdo pyetje, sugjerim apo bashkëpunim. Ekipi ynë është i gatshëm t'ju ndihmojë." />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://treguim.org/contact" />
        <meta property="og:image" content="https://treguim.org/logo512.png" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Kontakt | TreguIm" />
        <meta name="twitter:description" content="Na kontaktoni për çdo pyetje ose sugjerim. Ekipi ynë është këtu për t'ju ndihmuar." />
        <link rel="canonical" href="https://treguim.org/contact" />
        <script type="application/ld+json">
          {JSON.stringify(localBusinessSchema)}
        </script>
      </Helmet>
      
      <Navbar />
      
      <main className="flex-grow pt-16">
        <HeroSection />
        
        {/* Contact form & info section */}
        <section className="py-16">
          <div className="container mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex flex-col lg:flex-row gap-16">
              <ContactInfo />
              <ContactForm />
            </div>
          </div>
        </section>
        
        <MapSection />
      </main>
      
      <Footer />
    </div>
  );
};

export default Contact;
